export default __webpack_public_path__ + "static/media/club.14774f58.svg";